export default __webpack_public_path__ + "static/media/Users.db41f3a1.svg";